import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function SavoryPiesPage() {

    const heroData = [
        {
          title: "Savory Pies",
          content: "Our savory pies are packed with hearty fillings like meats, vegetables, and cheeses, all enveloped in a golden, flaky crust. Perfect as a comfort meal or a crowd-pleasing dish.",
          image: images.SavoryPiesHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Chicken & Mushroom Pie",
        content: "Tender chicken and mushrooms in a creamy filling, wrapped with pu pastry",
        price: 0,
        image: [
          images.SavoryPie1,
        ]
      },
      {
        name: "Beef Pie",
        content: "Slow-cooked beef in a rich gravy, wrapped in pu pastry",
        price: 0,
        image: [
          images.SavoryPie2,
        ]
      },
      {
        name: "Vegetable Pie",
        content: "A creamy mix of vegetables baked into a comforting pie",
        price: 0,
        image: [
          images.SavoryPie1,
        ]
      },
      {
        name: "Lamb Pie",
        content: "Sow cooked lamb between a flaky pastry",
        price: 0,
        image: [
          images.SavoryPie2,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Chicken & Mushroom Pie",
        image1: [
          images.SavoryPie1,
        ],
        content1: "Tender chicken and mushrooms in a creamy filling, wrapped with pu pastry",
        name2: "Beef Pie",
        image2: [
          images.SavoryPie2,
        ],
        content2: "Slow-cooked beef in a rich gravy, wrapped in pu pastry"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
